import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import styles from "../../styles/styles";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { serverAPI } from '../../server';
import { toast } from "react-toastify";

const SellerLogin = ({ setSellerToken, sellerRemember, setSellerRemember }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) return toast.warn("Fill up all the fields!");
        setLoading(true);
        axios.post(`${serverAPI}/seller/login-seller`, {
            email, password,
        }, { withCredentials: sellerRemember ? true : false })
            .then((res) => {
                setSellerToken(res.data.token);
                toast.success("Login Success!");
                navigate("/dashboard");
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div
            className="min-h-screen bg-gray-100 flex flex-col gap-1 justify-center py-12 sm:px-6 lg:px-8"
            style={{ backgroundImage: "url(/banner.jpg)" }}
        >
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <h2 className="text-center text-3xl font-extrabold font-Poppins text-gray-900">
                    Login as a Seller
                </h2>
            </div>
            <div className="sm:mx-auto sm:w-full sm:max-w-md font-Roboto">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={handleLogin}>

                        {/* EMAIL INPUT FIELD */}
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Your Email
                            </label>
                            <div className="mt-1">
                                <input
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={email}
                                    placeholder="Enter Email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    autoComplete="email"
                                />
                            </div>
                        </div>

                        {/* PASSWORD INPUT FIELD */}
                        <div>
                            <label htmlFor="password" className="block text-sm select-none font-medium text-gray-700">
                                Your Password
                            </label>
                            <div className="mt-1 relative">
                                <input
                                    className="appearance-none block w-full px-3 py-2 select-none border border-gray-300 rounded-md shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                    type={`${visible ? "text" : "password"}`}
                                    name="password"
                                    id="password"
                                    value={password}
                                    placeholder="Enter Password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoComplete="current-password"
                                />
                                {visible
                                    ? <AiOutlineEye
                                        className="absolute right-2 top-2 cursor-pointer"
                                        size={25}
                                        onClick={() => setVisible(false)}
                                    />
                                    : <AiOutlineEyeInvisible
                                        className="absolute right-2 top-2 cursor-pointer"
                                        size={25}
                                        onClick={() => setVisible(true)}
                                    />
                                }
                            </div>
                        </div>

                        {/* USER OPTIONS */}
                        <div className={`${styles.normalFlex} justify-between`}>
                            <div className={`${styles.normalFlex}`}>
                                <input
                                    className="text-blue-600 focus:ring-blue-500 border-gray-300 w-4 h-4 rounded"
                                    type="checkbox"
                                    name="remember-me"
                                    id="remember-me"
                                    onChange={() => setSellerRemember(prev => !prev)}
                                />
                                <label htmlFor="remember-me" className="mt-[2px] ml-2 block text-sm text-gray-900">
                                    Remember me
                                </label>
                            </div>
                            <div className="text-sm">
                                <Link to="/forgot" className="font-medium text-blue-600 hover:text-blue-500">
                                    Forgot your password?
                                </Link>
                            </div>
                        </div>

                        {/* LOGIN BUTTON */}
                        <div>
                            <button
                                disabled={loading}
                                type="submit"
                                className={`group ${loading ? "cursor-not-allowed" : "cursor-pointer"} relative w-full h-40px flex justify-center items-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${loading ? "bg-gray-400" : "bg-blue-600"} hover:${loading ? "bg-gray-500" : "bg-blue-700"}`}
                            >
                                {loading ? "Verifying..." : "LOGIN"}
                            </button>
                        </div>

                        {/* NEW USER */}
                        <div className={`${styles.normalFlex} w-full`}>
                            <h4>
                                Create Seller Account
                            </h4>
                            <Link to="/seller-signup" className="text-blue-600 pl-1">
                                here
                            </Link>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    )
}

export default SellerLogin